<template>
  <main>
    <LoaderOverlay :active="loading" />

    <div v-if="!loading && loadError" class="text-center py-[6.4rem]">
      {{ $t("Content temporarily unavailable") }}
    </div>

    <div
      v-else-if="!loading"
      class="mt-4 pt-0 pb-[4.8rem] container mx-auto sm:px-4 space-y-[2.4rem]"
    >
      <div class="mb-4">
        <AppButton
          :to="{ path: '/search/' }"
          variant="secondary"
          class="text-sm px-3 py-2"
        >
          <img
            src="@/assets/images/date-slider-left.svg"
            alt=""
            class="w-5 h-5"
          />
          <span>{{ $t("Back to search") }}</span>
        </AppButton>
      </div>
      <MainContent>
        <SubContent
          paddingClass="px-4 py-[1.2rem] bg-white-50 border border-white"
        >
          <div
            class="w-full flex relative items-center justify-between max-w-[784px] gap-5 sm:gap-[32px] mx-auto font-urbanist"
          >
            <button
              type="button"
              class="bg-[#FFFFFF] w-[48px] h-[48px] shrink-0 shadow-btn rounded-full flex items-center justify-center transition-transform duration-200 hover:-translate-y-[2px]"
              @click="prevDates"
            >
              <img :src="classArrowLeft" alt="" class="w-6 h-6" />
            </button>

            <div
              class="flex items-center gradient-fade-mask relative w-full justify-center gap-2 px-2 max-w-[624px]"
            >
              <button
                v-for="(item, index) in calendarItems"
                :key="item.iso"
                type="button"
                :class="[
                  'w-full shadow-btn py-2 px-2.5 flex gap-0.5 flex-col items-center justify-center rounded-[10px] transition-all duration-200',
                  isDateHiddenOnMobile(index, calendarItems.length)
                    ? 'max-sm:hidden'
                    : '',
                  item.selected ? 'bg-[#000000] text-white' : 'bg-[#FFFFFF]',
                ]"
                @click="setSelectedDate(item.iso)"
              >
                <span
                  :class="[
                    'font-urbanist font-[500] text-[12px] leading-[16px]',
                    item.selected ? 'text-white' : 'text-[#2D224480]',
                  ]"
                >
                  {{ item.month }}
                </span>
                <span
                  :class="[
                    'font-[400] text-[24px] leading-[24px]',
                    item.selected ? 'text-white' : 'text-[#2D2244]',
                  ]"
                >
                  {{ item.day }}
                </span>
                <span
                  :class="[
                    'font-urbanist font-[500] text-[12px] leading-[16px]',
                    item.selected ? 'text-white' : 'text-[#2D224480]',
                  ]"
                >
                  {{ item.weekday }}
                </span>
              </button>
            </div>

            <button
              type="button"
              class="bg-[#FFFFFF] w-[48px] h-[48px] shrink-0 shadow-btn rounded-full flex items-center justify-center transition-transform duration-200 hover:-translate-y-[2px]"
              @click="nextDates"
            >
              <img :src="classArrowRight" alt="" class="w-6 h-6" />
            </button>
          </div>
        </SubContent>
      </MainContent>

      <template v-if="!noClassesAvailable">
        <MainContent
          v-for="(section, index) in classSections"
          :key="section.key"
          class="space-y-[2.4rem]"
        >
          <div :ref="index === 0 ? 'scheduleSection' : null">
            <ClassSection
              :section="section"
              :is-primary="index === 0"
              :availability-loading="availabilityLoading"
              :availability-error="availabilityError"
            />
          </div>
        </MainContent>
      </template>
      <MainContent v-else>
        <SubContent class="class-section bg-white-50 border border-white">
          <section>
            <h2 class="class-section__title">{{ $t("Upcoming sessions") }}</h2>
            <div class="class-section__feedback">
              {{ $t("No availability for this specialist") }}
            </div>
          </section>
        </SubContent>
      </MainContent>
    </div>
  </main>
</template>

<script>
import classViewConfig from "./ClassView.logic";

export default classViewConfig;
</script>

<style scoped>
.font-urbanist {
  font-family: "Urbanist", sans-serif;
}

.font-manrope {
  font-family: "Manrope", sans-serif;
}

.shadow-btn {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.gradient-fade-mask {
  -webkit-mask-image: linear-gradient(
    90deg,
    rgba(217, 217, 217, 0) 0%,
    #d9d9d9 25%,
    #d9d9d9 75%,
    rgba(217, 217, 217, 0) 100%
  );
  -webkit-mask-size: 100% 100%;
  mask-image: linear-gradient(
    90deg,
    rgba(217, 217, 217, 0) 0%,
    #d9d9d9 25%,
    #d9d9d9 75%,
    rgba(217, 217, 217, 0) 100%
  );
  mask-size: 100% 100%;
}

.class-section__title {
  margin: 0 0 1.6rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: #000000;
}

.class-section__feedback {
  padding: 2.4rem 0;
  color: rgba(45, 34, 68, 0.6);
  font-size: 1.4rem;
  text-align: center;
}
</style>
